import { render, staticRenderFns } from "./Allergene.vue?vue&type=template&id=e271784e&scoped=true"
import script from "./Allergene.vue?vue&type=script&lang=js"
export * from "./Allergene.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e271784e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\Projekte2025\\Ezchicken\\ezchickenapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e271784e')) {
      api.createRecord('e271784e', component.options)
    } else {
      api.reload('e271784e', component.options)
    }
    module.hot.accept("./Allergene.vue?vue&type=template&id=e271784e&scoped=true", function () {
      api.rerender('e271784e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Allergene.vue"
export default component.exports